export default class SingletonError extends Error {
    constructor(singletonName: string, methodName = 'getInstance') {
        super(`Tried to instantiate ${singletonName} without static method ${methodName}`);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
